import { createAction } from '@reduxjs/toolkit'
import { DrawingFile, LoadingPage } from '../models/File'

export const setPermitFile = createAction<{ permitFile: DrawingFile }>(
  'permit/setPermitFile',
)
export const updatePermitPage = createAction<{
  fileId: string
  page: LoadingPage
}>('permit/updatePage')
export const setSelectedPage = createAction<{ pageId: string }>(
  'permit/setSelectedPage',
)
export const activateTool = createAction<string>('permit/activateTool')
